<template>
  <span
    :class="{ target_name__dropped: isDropped }"
    :title="params.value"
  >
    <template v-if="justDisplayNameOfTarget">
      <span>
        {{ params.value }}
      </span>
    </template>
    <template v-else-if="hasTargetAction(params.data)">
      <span
        class="audience-hub-table__target-name"
        @click="openTarget"
      >
        <v-icon
          v-if="showPostSymbol"
          color="green"
          medium
          >mdi-chart-line</v-icon
        >
        {{ params.value }}
      </span>
    </template>
    <template v-else>
      <span
        class="audience-hub-table__target-name"
        @click="openWorkbench"
      >
        {{ params.value }}
      </span>
    </template>
  </span>
</template>

<script>
  import { targetTypeToAbbrev, targetRouteHandler } from '@/helpers'
  import { SET_BACK_ROUTE_OVERRIDE } from '@/appLogic/route/store/actions'
  import {
    TARGET_TYPE,
    ACTIVATION_STATUS,
    LAS_TYPES,
    TARGET_ACTIONS,
    INTENTS,
    DESTINATIONS,
  } from '@/appLogic/targets/Constants'
  import { SET_STEPPER_DATA_SOURCE } from '@/appLogic/targets/createTarget/store/actions'
  import { SET_SHOW_APPEND_MODAL } from '@/appLogic/targets/currentTarget/store/actions'
  import Icon from 'vue-awesome/components/Icon'

  export default {
    components: {
      Icon,
    },
    data: () => {
      return {
        targetTypeToAbbrev,
      }
    },
    computed: {
      hrefURL() {
        if (!this.isLASAndActivated) {
          if (this.isSalesIntent) {
            return '/#/aw/' + this.params.data.id
          } else {
            return '/#/workbench/' + this.targetTypeToAbbrev[this.params.data.target] + '/' + this.params.data.id
          }
        }
      },
      actionLinkClass() {
        if (this.isCDPDatasource) {
          return 'target_name__xandr'
        } else {
          return
        }
      },
      isNew() {
        return this.params.data.activation_status === ACTIVATION_STATUS.NEW
      },
      isActivated() {
        return this.params.data.activation_status === ACTIVATION_STATUS.ACTIVATED
      },
      isSubmitted() {
        return this.params.data.activation_status === ACTIVATION_STATUS.SUBMITTED
      },
      isPID() {
        return this.params.data.target === TARGET_TYPE.PID
      },
      isNpower() {
        return this.params.data.target === TARGET_TYPE.NPOWER
      },
      isComscore() {
        return this.params.data.target === TARGET_TYPE.COMSCORE
      },
      isLASAndActivated() {
        return this.params.data.target === TARGET_TYPE.LAS && this.isActivated
      },
      isSalesIntent() {
        return (
          this.params.data.metadata.intents &&
          this.params.data.metadata.intents.some(i => i['Name'] === INTENTS['Sales']['Name'])
        )
      },
      isLive() {
        return this.params.data.activation_status === ACTIVATION_STATUS.LIVE
      },
      isATTAMNativeLAS() {
        return (
          this.params.data.target === TARGET_TYPE.ATT &&
          [
            ACTIVATION_STATUS.ACTIVATED,
            ACTIVATION_STATUS.SUBMITTED,
            ACTIVATION_STATUS.FAILED,
            ACTIVATION_STATUS.LIVE,
          ].includes(this.params.data.activation_status)
        )
      },
      nielsenDatasources() {
        return this.$store.getters.getNielsenDatasources
      },
      C360Datasources() {
        return this.$store.getters.getC360Datasources
      },
      isNcs() {
        return this.params.data.target_datasource === this.nielsenDatasources.NCS
      },
      username() {
        return this.$store.state.auth.username
      },
      justDisplayNameOfTarget() {
        return (
          [TARGET_TYPE.COMSCORE_TV].includes(this.params.data.target) ||
          ([TARGET_TYPE.NPOWER, TARGET_TYPE.COMSCORE, TARGET_TYPE.PID].includes(this.params.data.target) &&
            !this.isActivated)
        )
      },
      showPostSymbol() {
        return this.isNew && !this.isNcs && !this.isATTAMNativeLAS
      },
      isActivatedPID() {
        return this.isActivated && this.isPID
      },
      isActivatedNPower() {
        return this.isActivated && this.isNpower
      },
      isActivatedComscore() {
        return this.isActivated && this.isComscore
      },
      isDropped() {
        return this.params.data.dropped
      },
      isCDPDatasource() {
        return Object.values(this.C360Datasources).includes(this.params.data.target_datasource)
      },
      isAddressableOrDigitalTarget() {
        return (
          this.isCDPDatasource &&
          (this.params.data.destinations.includes(DESTINATIONS.DIRECTV) ||
            this.params.data.destinations.includes(DESTINATIONS.VIZIO) ||
            this.params.data.destinations.includes(DESTINATIONS.CANOE_LINEAR) ||
            this.params.data.destinations.includes(DESTINATIONS.CANOE_VOD) ||
            this.params.data.destinations.includes(DESTINATIONS.FREEWHEEL) ||
            this.params.data.destinations.includes(DESTINATIONS.GOOGLE_AD_MANAGER) ||
            this.params.data.destinations.includes(DESTINATIONS.VIDEOAMP))
        )
      },
    },
    methods: {
      hasTargetAction(target) {
        switch (target.target) {
          // case TARGET_TYPE.OPEN_AP:  // deprecated because no longer support of Open AP
          case TARGET_TYPE.ADSTRA:
          case TARGET_TYPE.XANDR_SEGMENT:
          case TARGET_TYPE.PRISM:
          case TARGET_TYPE.DNB:
          case TARGET_TYPE.MAX:
          case TARGET_TYPE.TVE:
          case TARGET_TYPE.EPSILON:
          case TARGET_TYPE.DISCOVERY_PLUS:
          case TARGET_TYPE.DCR:
          case TARGET_TYPE.VIDEOAMP:
          case TARGET_TYPE.LIVERAMP:
          case TARGET_TYPE.WBGAMES:
          case TARGET_TYPE.RETARGETING:
          case TARGET_TYPE.FREEWHEEL:
          case TARGET_TYPE.GOOGLE_AD_MANAGER:
          case TARGET_TYPE.LAL:
          case TARGET_TYPE.DC_COMICS:
          case TARGET_TYPE.CNN:
            return this.isActivated
          case TARGET_TYPE.ATT:
            return true
          case TARGET_TYPE.LAS:
          case TARGET_TYPE.PID:
          case TARGET_TYPE.NPOWER:
          case TARGET_TYPE.COMSCORE:
            return this.isActivated
          default:
            return false
        }
      },
      setBackRoute() {
        // set back route override value in case user is viewing all targets
        // ensures user returns to audience hub viewing all targets when 'ROUTE_BACK' action is called
        this.$store.dispatch(SET_BACK_ROUTE_OVERRIDE, this.$router.currentRoute.path)
      },
      openWorkbench() {
        this.$store.dispatch(SET_BACK_ROUTE_OVERRIDE, this.$router.currentRoute.path)
        if (!this.isLASAndActivated) {
          if (this.isSalesIntent) {
            this.$router.push({ path: '/aw/' + this.params.data.id })
          } else {
            this.$router.push({
              path: '/workbench/' + this.targetTypeToAbbrev[this.params.data.target] + '/' + this.params.data.id,
            })
          }
        }
      },
      openTarget() {
        if (this.params.data.target === TARGET_TYPE.LAS) {
          if (!this.isActivated) {
            this.$store.dispatch(SET_STEPPER_DATA_SOURCE, {
              target_id: this.params.data.id,
              option: this.params.data.target_datasource,
              targetAction: TARGET_ACTIONS.UPDATE,
            })
          }
        } else if (this.isATTAMNativeLAS) {
          this.$store.dispatch(SET_STEPPER_DATA_SOURCE, {
            target_id: this.params.data.id,
            option: this.nielsenDatasources.FILE,
            targetAction: TARGET_ACTIONS.UPDATE,
          })
        } else if (this.isActivatedPID) {
          this.$store.dispatch(SET_STEPPER_DATA_SOURCE, {
            target_id: this.params.data.id,
            option: this.nielsenDatasources.FILE,
            targetAction: TARGET_ACTIONS.UPDATE,
          })
        } else if (this.isActivatedNPower || this.isActivatedComscore) {
          this.$store.dispatch(SET_SHOW_APPEND_MODAL, { target: this.params.data })
        } else if (this.isCDPDatasource) {
          if (this.isActivated) {
            // Open Segment Info for Addressable targets in Activated status
            // Do not open update modal or workbench for Addressable and Digital targets in Activated status
            if (!this.isAddressableOrDigitalTarget) {
              this.$store.dispatch(SET_STEPPER_DATA_SOURCE, {
                target_id: this.params.data.id,
                option: LAS_TYPES.XANDR,
                targetAction: TARGET_ACTIONS.UPDATE,
              })
            }
          } else {
            this.$router.push({ name: 'XandrWorkbench', params: { id: this.params.data.id } })
          }
        } else {
          targetRouteHandler('OPEN', this.params.data)
        }
      },
    },
  }
</script>

<style lang="scss">
  .target_name {
    &__icons {
      color: green;
    }
  }
  .target_name__dropped {
    color: red;
    a {
      color: red;
    }
  }

  .target_name__xandr {
    text-decoration: none;
    color: black;

    &:hover {
      color: #ffbd00;
      cursor: pointer;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// TargetNameRenderer.vue?2650b617